import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import { useConfig } from "@/hooks/useConfig";
import { Reveal } from "@/components/Reveal";

const FACTS = [["90", "acres of greenery"], ["244", "villas"], ["4", "dining outlets"], ["2", "banquet halls"]];

export default function About() {
  useSeo("About The Ananta Udaipur", "About The Ananta Udaipur: a 90-acre 5-star resort in the Aravalli Hills with 244 villas, 4 dining outlets, spa, pool, gym and kids area. Part of The Ananta Hotels.");
  const cfg = useConfig();
  const paras = (cfg.about_text || "").split(/\n\s*\n/).map((t) => t.trim()).filter(Boolean);
  return (
    <>
      <section className="container-x py-16 sm:py-24 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6">
          <p className="eyebrow text-[#C28B5E]">About the property</p>
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl text-[#1E3B2E] tracking-tight leading-[1.02]">The Ananta Udaipur</h1>
          {paras.length ? paras.map((t, n) => <p key={n} className={`${n ? "mt-4" : "mt-6"} text-[15px] leading-8 text-[#3b3b3b] whitespace-pre-line`} data-testid={`about-text-${n}`}>{t}</p>) : <>
          <p className="mt-6 text-[15px] leading-8 text-[#3b3b3b]">Set against a breathtaking backdrop of the Aravalli Hills, The Ananta Udaipur creates a fairytale experience for guests with the choicest of 5-star luxuries on offer. Sprawling across 90 acres of lush greenery, the resort encompasses 244 opulent villas, 4 eclectic dining outlets and 2 banquet halls.</p>
          <p className="mt-4 text-[15px] leading-8 text-[#3b3b3b]">With an outdoor swimming pool, a rejuvenating spa, a well-equipped gym and a special kids activity area, the resort is a unique escape in the beautiful City of Lakes.</p>
          </>}
        </div>
        <Reveal className="lg:col-span-6 overflow-hidden aspect-[4/3]"><img src="/images/udaipur/aerial.jpg" alt="The Ananta Udaipur resort" className="h-full w-full object-cover" /></Reveal>
      </section>
      <section className="bg-[#1E3B2E] text-[#FDFBF7] py-16">
        <div className="container-x grid grid-cols-2 md:grid-cols-4 gap-8">
          {FACTS.map(([n, l]) => <div key={l}><p className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl">{n}</p><p className="eyebrow text-[#E5D9C5] mt-2">{l}</p></div>)}
        </div>
      </section>
      <section className="container-x py-20 sm:py-28 grid lg:grid-cols-2 gap-12">
        <div>
          <p className="eyebrow text-[#C28B5E]">The Ananta Hotels</p>
          <h2 className="mt-3 text-4xl text-[#1E3B2E] tracking-tight">Gateway to serenity</h2>
        </div>
        <div className="text-[15px] leading-8 text-[#3b3b3b] space-y-4">
          <p>With properties across India, The Ananta Hotels epitomises luxury in blissful settings, with a promise of service excellence delivered by attentive staff.</p>
          <p>Spread across acres of lush greenery, the resorts encompass speciality restaurants, complemented by a host of wellness and recreation facilities including fitness centres, pools, sauna and steam rooms.</p>
          <Link to="/destinations" className="btn-primary mt-4" data-testid="about-destinations-btn">Explore destinations</Link>
        </div>
      </section>
    </>
  );
}
